"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PopoverTrigger: function() {
        return _index.PopoverTrigger;
    },
    renderPopoverTrigger_unstable: function() {
        return _index.renderPopoverTrigger_unstable;
    },
    usePopoverTrigger_unstable: function() {
        return _index.usePopoverTrigger_unstable;
    }
});
const _index = require("./components/PopoverTrigger/index");
